@use 'sass:map';
@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@use '@helsenorge/designsystem-react/scss/palette' as palette;
@use '@helsenorge/designsystem-react/scss/font-settings' as font-settings;
@import '@helsenorge/designsystem-react/scss/breakpoints';

.feedbackform {
  padding: spacers.getSpacer(l) 0;
  background-color: palette.$neutral50;
  border-top: 1px solid palette.$plum700;

  @media (min-width: map.get($grid-breakpoints, md)) {
    padding: spacers.getSpacer(xl) 0;
  }

  @media print {
    display: none;
  }

  &__scores {
    display: flex;
    align-items: center;
    gap: spacers.getSpacer(s);
  }

  &__icon {
    margin-right: spacers.getSpacer(xs);
  }

  &__buttons {
    display: flex;
    align-items: center;
    gap: spacers.getSpacer(s);
  }
}
